import { getLts } from '@/app_lib/services/Piano/pianoHelpers';
import type { Tinypass } from '@/app_lib/types/piano/tinypass';
import type { DataLayerEventName, EventData } from '@/app_lib/types/Gtm';

interface PianoTemplateTrackingEvent {
  eventName: string;
  type: string;
  params: {
    contentPlacement?: string;
    displayMode: string;
    clickText?: string;
    clickType?: 'close' | 'cta button' | 'expand' | 'collapse' | 'sign in link';
    formName?: string;
    experienceId?: string;
  };
}

export const pianoTemplateTrackingEvent = (
  tp: Tinypass,
  event: PianoTemplateTrackingEvent,
  sendEventOnConsent: (eventData: EventData, eventType?: DataLayerEventName) => void,
) => {
  switch (event.type) {
    case 'nlTemplateClick': {
      const { contentPlacement, displayMode, clickText, clickType } = event.params;

      const templateTrackingPayload = {
        displayMode,
        eventAction: 'newsletter template clicked',
        eventCategory: 'piano template',
        eventLabel: 'user clicked on newsletter template',
        manualClickText: clickText,
        manualClickType: clickType,
        manualContentPlacement: contentPlacement,
      };

      sendEventOnConsent(templateTrackingPayload);
      break;
    }
    case 'templateFormStart': {
      const { displayMode, formName, experienceId } = event.params;

      const lts = experienceId ? getLts(tp, experienceId, 'showTemplate') : null;

      const templateTrackingPayload = {
        displayMode,
        eventAction: 'template form started',
        eventCategory: 'piano template',
        eventLabel: 'user started filling out template form',
        formName,
        // biome-ignore lint/style/useNamingConvention: external usage
        logged_in: Boolean(tp.pianoId.getUser()),
        lts,
      };

      sendEventOnConsent(templateTrackingPayload);
      break;
    }
    case 'templateFormSubmitted': {
      const { displayMode, formName, experienceId } = event.params;

      const lts = experienceId ? getLts(tp, experienceId, 'showTemplate') : null;

      const templateTrackingPayload = {
        displayMode,
        eventAction: 'template form submitted',
        eventCategory: 'piano template',
        eventLabel: 'user successfully submitted template form',
        formName,
        // biome-ignore lint/style/useNamingConvention: external usage
        logged_in: Boolean(tp.pianoId.getUser()),
        lts,
      };

      sendEventOnConsent(templateTrackingPayload);
      break;
    }
    default:
      break;
  }
};
